import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import locale from "@amcharts/amcharts4/lang/pt_BR.js";
import { weatherIcons } from "../assets/icons.js";
import { setArquivoPDF } from "../displayPDF/displayPDFActions.js";
const { customizeChartGrip } = require("../utils/customizeChartGrip");

export function setModoTela(modo, registro = {}) {
    return {
        type: "GERACAO_LEITURA_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "GERACAO_LEITURA_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function setFiltro(filtro) {
    return {
        type: "GERACAO_LEITURA_FILTRO",
        payload: filtro,
    };
}

export function setDataGrafico(data) {
    return {
        type: "GERACAO_LEITURA_SET_DATA_GRAFICO",
        payload: data,
    };
}

export async function gerarRelatorio({ html, landscape, scale }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const response = await axios.post(`${consts.API_URL}/relatorio`, { html, landscape, scale }, { responseType: "blob" });

            const reader = new FileReader();

            reader.onloadend = () => {
                const pdfBase64 = reader.result;
                dispatch(setArquivoPDF(pdfBase64, "Relatório.pdf", landscape ? "landscape" : "portrait"));
                dispatch(setAguardando(false));
            };

            reader.onerror = () => {
                console.error("Erro ao ler blob para base64");
                dispatch(setAguardando(false));
                setError("Erro ao processar o relatório");
            };

            reader.readAsDataURL(response.data);
        } catch (erro) {
            console.log(erro);
            dispatch(setAguardando(false)); // <<< chama aqui no catch também
            setError("Erro ao gerar o relatório");
        }
    };
}
export async function gerarXlsx({ nomeArquivo, dados }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const response = await axios.post(`${consts.API_URL}/gerarXlsx`, { nomeArquivo, dados }, { responseType: "blob" });
            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${nomeArquivo}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            dispatch(setAguardando(false));
        } catch (erro) {
            setError("Erro ao gerar o relatório");
        }
    };
}


export function getLista() {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        const aguardando = getState().geracaoLeitura.aguardando;
        if (!usuarioLogado || aguardando) return {};

        dispatch({
            type: "GERACAO_LEITURA_LISTADO",
            payload: { data: [] },
        });

        //ALTERADO PRA CARREGAR A LISTA INTEIRA UMA VEZ E DEPOIS FILTRAR O QUE JÁ ESTA CARREGADO NO FRONT
        try {
            dispatch(setAguardando(true));
            
            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const { id_cliente, id_unidade_consumidora, id_geracao_integracao_tipo, id_agrupador, agrupar_por_uc } = getState().geracaoLeitura.filtro;
            const resp = await axios.get(
                `${consts.API_URL}/geracaoLeitura?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&id_geracao_integracao_tipo=${id_geracao_integracao_tipo}&id_agrupador=${
                    //pode ser id_geracao_integracao (modo individual) ou id da UC (modo agrupado por UC)
                    id_agrupador
                }&agrupar_por_uc=${agrupar_por_uc}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "GERACAO_LEITURA_LISTADO",
                payload: resp,
            });
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getListaBalancoEnergetico({ id_cliente, id_unidade_geradora, ano, mes }) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        const aguardando = getState().geracaoLeitura.aguardando;
        if (!usuarioLogado || aguardando) return {};
        try {
            dispatch({
                type: "GERACAO_LEITURA_LISTA_BALANCO_ENERGETICO",
                payload: { data: [] },
            });
            dispatch(setAguardando(true));

            const resp = await axios.get(
                `${consts.API_URL}/gestao-credito-solar/listar-balanco-energetico?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&id_unidade_geradora=${id_unidade_geradora}&ano=${ano}&mes=${mes}`
            );
            dispatch({
                type: "GERACAO_LEITURA_LISTA_BALANCO_ENERGETICO",
                payload: resp,
            });
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export async function incluirEnergiaDia({ registro, callback }) {
    return async (dispatch, getState) => {
        try {
            await axios.post(`${consts.API_URL}/geracaoLeitura/energiaDia`, registro);
            if (callback) callback();
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export async function incluirEnergiaMes({ registro, callback }) {
    return async (dispatch, getState) => {
        try {
            await axios.post(`${consts.API_URL}/geracaoLeitura/energiaMes`, registro);
            if (callback) callback();
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export async function incluirEnergiaAno({ registro, callback }) {
    return async (dispatch, getState) => {
        try {
            await axios.post(`${consts.API_URL}/geracaoLeitura/energiaAno`, registro);
            if (callback) callback();
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export async function atualizarCalculoAmpliacaoPorUc(filtro) {
    try {
        const resp = await axios.get(
            `${consts.API_URL}/geracaoLeitura/listarCalculoAmpliacaoPorUc?id_unidade_consumidora=${filtro.id_unidade_consumidora}&competencia_inicial=${filtro.competencia_inicial}&competencia_final=${filtro.competencia_final}`
        );
        return resp.data;
    } catch (erro) {
        setError("Não foi possível atualizar o cálculo de ampliação com o período selecionado");
    }
}

export async function getListaCalculoAmpliacaoPorUc() {
    return async (dispatch, getState) => {
        try {
            dispatch({
                type: "GERACAO_LEITURA_CALCULO_AMPLIACAO_POR_UC",
                payload: { data: [] },
            });

            const resp = await axios.get(`${consts.API_URL}/geracaoLeitura/listarCalculoAmpliacaoPorUc`);
            dispatch({
                type: "GERACAO_LEITURA_CALCULO_AMPLIACAO_POR_UC",
                payload: resp,
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

// export async function calcularAmplicacaoPorId({ id_geracao_integracao, id_unidade_consumidora }) {
//     try {
//         const filtroGeracaoIntegracao = id_geracao_integracao ? `id_geracao_integracao=${id_geracao_integracao}` : "";
//         const filtroUnidadeConsumidora = id_unidade_consumidora ? `id_unidade_consumidora=${id_unidade_consumidora}` : "";
//         const resp = await axios.get(`${consts.API_URL}/geracaoLeitura/calcularAmplicacaoPorId?${filtroGeracaoIntegracao || filtroUnidadeConsumidora}`);
//         return resp.data;
//     } catch (erro) {
//         setErroAPI(erro);
//     }
// }

export function getModulos(idUnidadeConsumidora) {
    return async (dispatch, getState) => {
        if (!idUnidadeConsumidora) {
            dispatch({
                type: "GERACAO_LEITURA_MODULOS_LISTADO",
                payload: { data: [] },
            });
            return {};
        }
        //evita buscar 2 vezes enquanto jáesta buscando a primeira vez
        if (getState().geracaoLeitura.aguardando) return {};
        dispatch({
            type: "GERACAO_LEITURA_SET_AGUARDANDO",
            payload: true,
        });
        //ALTERADO PRA CARREGAR A LISTA INTEIRA UMA VEZ E DEPOIS FILTRAR O QUE JÁ ESTA CARREGADO NO FRONT
        try {
            const resp = await axios.get(`${consts.API_URL}/geracaoComAmpliacao?id_unidade_consumidora=${idUnidadeConsumidora}`);
            dispatch({
                type: "GERACAO_LEITURA_MODULOS_LISTADO",
                payload: resp,
            });
            dispatch({
                type: "GERACAO_LEITURA_SET_AGUARDANDO",
                payload: false,
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function getListaGraficoGeracaoSaldo({ id_cliente, id_unidade_consumidora }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};
            dispatch({
                type: "GERACAO_LEITURA_GRAFICO_GERACAO_SALDO_LISTADO",
                payload: [],
            });
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoSaldo?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : id_cliente}
			&ids_unidades_consumidoras=${encodeURIComponent([id_unidade_consumidora])}`
            );
            dispatch({
                type: "GERACAO_LEITURA_GRAFICO_GERACAO_SALDO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function salvarManutencaoSolarHistorico({ registro, callback }) {
    const registroFormatado = { ...registro };

    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch(setAguardando(true));
            if (!registro.id) {
                registroFormatado.id_usuario_inclusao = usuarioLogado.id;
                await axios.post(`${consts.API_URL}/manutencaoSolarHistorico`, registroFormatado);
            } else {
                registroFormatado.id_usuario_alteracao = usuarioLogado.id;
                await axios.put(`${consts.API_URL}/manutencaoSolarHistorico`, registroFormatado);
            }

            //DEVE ATUALIZAR A LISTA DE MANUTENÇÃO DA LEITURA
            const resposta = await axios.get(`${consts.API_URL}/manutencaoSolarHistorico?id_unidade_consumidora=${registro.id_unidade_consumidora}`);
            const listaManutencaoAtualizada = resposta.data;

            const leiturasUcAlterada = getState().geracaoLeitura.lista.filter((item) => item.id_unidade_consumidora == registro.id_unidade_consumidora);
            for (const leitura of leiturasUcAlterada) {
                leitura.manutencoes = [...listaManutencaoAtualizada];
            }
            setSuccess("Operação Realizada com sucesso.");
            callback();
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluirManutencaoSolarHistorico({ registro, callback }) {
    return async (dispatch, getState) => {
        try {
            if (!window.confirm("Deseja realmente excluir o registro?")) return {};
            dispatch(setAguardando(true));
            await axios.delete(`${consts.API_URL}/manutencaoSolarHistorico?id=${registro.id}`);

            //DEVE ATUALIZAR A LISTA DE MANUTENÇÃO DA LEITURA
            const resposta = await axios.get(`${consts.API_URL}/manutencaoSolarHistorico?id_unidade_consumidora=${registro.id_unidade_consumidora}`);
            const listaManutencaoAtualizada = resposta.data;

            const leiturasUcAlterada = getState().geracaoLeitura.lista.filter((item) => item.id_unidade_consumidora == registro.id_unidade_consumidora);
            for (const leitura of leiturasUcAlterada) {
                leitura.manutencoes = [...listaManutencaoAtualizada];
            }
            setSuccess("Operação Realizada com sucesso.");
            callback();
        } catch (erro) {
            console.log(erro);
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function setStatusVisualizado(idOuListaIds) {
    return (dispatch, getState) => {
        if (window.confirm("Deseja realmente desabilitar o alerta para o registro selecionado?"))
            axios
                .patch(`${consts.API_URL}/geracaoLeitura`, { idOuListaIds })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch({
                        type: "GERACAO_LEITURA_SET_STATUS_VISUALIZADO",
                        payload: idOuListaIds,
                    });
                })
                .catch((e) => {
                    setErroAPI(e);
                });
    };
}

export async function getGeracaoCadastro({ id_cliente, id_unidade_consumidora }) {
    return async (dispatch, getState) => {
        try {
            if (!id_cliente || !id_unidade_consumidora) {
                setError("Dados inválidos");
                return {};
            }

            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "GERACAO_LEITURA_GRAFICO_GERACAO_CADASTRO_LISTADO",
                payload: { data: [] },
            });

            const resp = await axios.get(
                `${consts.API_URL}/geracao?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    id_unidade_consumidora
                )}&listarUltimaCadastradaEmDiante=true`
            );

            dispatch({
                type: "GERACAO_LEITURA_GRAFICO_GERACAO_CADASTRO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function getListaGraficoGeracaoEconomia({ id_cliente, id_unidade_consumidora }) {
    return async (dispatch, getState) => {
        try {
            if (!id_cliente || !id_unidade_consumidora) {
                setError("Dados inválidos");
                return {};
            }
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            dispatch({
                type: "GERACAO_LEITURA_GRAFICO_GERACAO_ECONOMIA_LISTADO",
                payload: { data: [] },
            });

            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoEconomia?id_usuario_logado=${
                    usuarioLogado.id
                }&id_cliente=${id_cliente}&ids_unidades_consumidoras=${encodeURIComponent(id_unidade_consumidora)}&competencia_inicial=${null}&competencia_final=${null}`
            );

            dispatch({
                type: "GERACAO_LEITURA_GRAFICO_GERACAO_ECONOMIA_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaGraficoTodasIntegracoesAgrupadasPorHora({ dataGrafico, intervaloTempo, id_cliente, id_unidade_consumidora, id_geracao_integracao_tipo }) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        let data = [];
        try {
            const resposta = await axios.get(
                `${consts.API_URL}/geracaoLeitura/listarGraficoTodasIntegracoesAgrupadasPorIntervaloTempo?id_usuario_logado=${usuarioLogado.id}&id_cliente=${id_cliente}&id_unidade_consumidora=${id_unidade_consumidora}&id_geracao_integracao_tipo=${id_geracao_integracao_tipo}&data=${dataGrafico}&intervalo_tempo=${intervaloTempo}`
            );
            data = resposta.data;
        } catch (erro) {
            setError("Erro ao buscar dados do gráfico geral");
        }
        dispatch({
            type: "GERACAO_LEITURA_LISTA_GRAFICO_TODAS_INTEGRACOES_AGRUPADAS_POR_HORA",
            payload: { data, dataGrafico, intervaloTempo },
        });
    };
}

export function getListaGraficoEnergiaDia({ id_agrupador, data }) {
    return (dispatch, getState) => {
        dispatch({
            type: "GERACAO_LEITURA_LISTA_GRAFICO_ENERGIA_DIA",
            payload: { data: [] },
        });

        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        const agruparPorUc = getState().geracaoLeitura.filtro.agrupar_por_uc;
        const resposta = axios.get(
            `${consts.API_URL}/geracaoLeitura/listaGraficoEnergiaDia?id_usuario_logado=${usuarioLogado.id}&id_agrupador=${id_agrupador}&data=${data}&agrupar_por_uc=${agruparPorUc}`
        );
        dispatch({
            type: "GERACAO_LEITURA_LISTA_GRAFICO_ENERGIA_DIA",
            payload: resposta,
        });
    };
}

export function getListaGraficoEnergiaDiasMes({ id_agrupador, data }) {
    return (dispatch, getState) => {
        dispatch({
            type: "GERACAO_LEITURA_LISTA_GRAFICO_ENERGIA_DIAS_MES",
            payload: { data: [] },
        });
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        const agruparPorUc = getState().geracaoLeitura.filtro.agrupar_por_uc;
        try {
            const resposta = axios.get(
                `${consts.API_URL}/geracaoLeitura/listaGraficoEnergiaDiasMes?id_usuario_logado=${usuarioLogado.id}&id_agrupador=${id_agrupador}&data=${data}&agrupar_por_uc=${agruparPorUc}`
            );

            dispatch({
                type: "GERACAO_LEITURA_LISTA_GRAFICO_ENERGIA_DIAS_MES",
                payload: resposta,
            });
        } catch (erro) {
            //console.log(erro);
        }
    };
}

export function getListaGraficoEnergiaMesesAno({ id_agrupador, data }) {
    return (dispatch, getState) => {
        dispatch({
            type: "GERACAO_LEITURA_LISTA_GRAFICO_ENERGIA_MESES_ANO",
            payload: { data: [] },
        });

        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        const agruparPorUc = getState().geracaoLeitura.filtro.agrupar_por_uc;
        const resposta = axios.get(
            `${consts.API_URL}/geracaoLeitura/listaGraficoEnergiaMesesAno?id_usuario_logado=${usuarioLogado.id}&id_agrupador=${id_agrupador}&data=${data}&agrupar_por_uc=${agruparPorUc}`
        );

        dispatch({
            type: "GERACAO_LEITURA_LISTA_GRAFICO_ENERGIA_MESES_ANO",
            payload: resposta,
        });
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "GERACAO_LEITURA_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "GERACAO_LEITURA_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaManutencaoTipo() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const request = axios.get(`${consts.API_URL}/manutencaoTipo/listarSelect`);
            dispatch({
                type: "GERACAO_LEITURA_MANUTENCAO_TIPO_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function montarGraficoLineEnergiaDia({ id, lista, setChart, subtitulo }) {
    am4core.useTheme(am4themes_animated);

    let chart = am4core.create(id, am4charts.XYChart);
    const subtitle = chart.titles.create();
    subtitle.text = subtitulo;
    subtitle.fontWeight = "bold";
    subtitle.fontSize = window.innerWidth < 1150 ? "0.7rem" : "1rem";
    subtitle.fill = am4core.color("#000");
    subtitle.marginBottom = 30;

    const title = chart.titles.create();
    title.text = "Energia Gerada no Dia";
    title.fontWeight = "bold";
    title.fontSize = window.innerWidth < 1150 ? "0.8rem" : "1.2rem";
    title.fill = am4core.color("#000");
    title.marginBottom = 30;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.items = [
        {
            label: "...",
            menu: [
                {
                    type: "png",
                    label: "PNG",
                },
            ],
        },
    ];
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.5;
    dateAxis.dateFormats.setKey("minute", "HH:mm");
    // dateAxis.periodChangeDateFormats.setKey("minute", "hh:mm");
    dateAxis.baseInterval = {
        timeUnit: "minute",
        count: 5,
    };
    dateAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo x
    dateAxis.renderer.maxLabelPosition = 0.95;
    dateAxis.renderer.minGridDistance = 40;
    dateAxis.renderer.minLabelPosition = 0.05;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    if (chart.yAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
    }
    valueAxis.min = 0;
    valueAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo y
    // Create series
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = "potencia_instantanea";
    series.dataFields.dateX = "data_hora";
    series.yAxis = valueAxis;
    series.name = "Energia gerada ao longo do dia";
    series.tooltipText = `Potência Instantânea às {dateX.formatDate("HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`;
    series.strokeWidth = 2;
    series.tensionX = 1;
    series.stacked = true;
    series.stroke = am4core.color("#017acd");
    series.fill = am4core.color("#017acd");
    series.fillOpacity = 0.2;

    const seriesPotenciaInstalada = chart.series.push(new am4charts.LineSeries());
    seriesPotenciaInstalada.dataFields.valueY = "potencia_instalada";
    seriesPotenciaInstalada.dataFields.dateX = "data_hora";
    seriesPotenciaInstalada.yAxis = valueAxis;
    seriesPotenciaInstalada.name = "Potência Instalada";
    seriesPotenciaInstalada.tooltipText = `Potência Máxima [bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`;
    seriesPotenciaInstalada.strokeWidth = 3;
    seriesPotenciaInstalada.tensionX = 1;
    seriesPotenciaInstalada.stacked = false;
    seriesPotenciaInstalada.stroke = am4core.color("#cd0131");
    seriesPotenciaInstalada.tooltip.getFillFromObject = false;
    seriesPotenciaInstalada.tooltip.background.fill = am4core.color("#cd0131"); // vermelho
    seriesPotenciaInstalada.tooltip.background.stroke = am4core.color("#fff");
    seriesPotenciaInstalada.tooltip.background.strokeWidth = 0;
    seriesPotenciaInstalada.tooltip.background.cornerRadius = 3;
    seriesPotenciaInstalada.tooltip.background.pointerLength = 0;

    //Estilo da scrollbar
    chart.scrollbarX = new am4charts.XYChartScrollbar();
    chart.scrollbarX.series.push(series);
    chart.scrollbarX.unselectedOverlay.fill = am4core.color("#fff");
    chart.scrollbarX.unselectedOverlay.fillOpacity = 0.7;
    chart.scrollbarX.unselectedOverlay.stroke = am4core.color("#fff");

    chart.scrollbarX.background.fill = am4core.color("#fff");
    chart.scrollbarX.thumb.background.fill = am4core.color("#2190ff"); //cor do trecho selecionado
    chart.scrollbarX.thumb.background.fillOpacity = 0.3; //opacidade da cor do trecho selecionado
    chart.scrollbarX.stroke = am4core.color("#003040"); // cor do texto dentro do trecho seleionado
    chart.scrollbarX.strokeWidth = 0;

    //Cor da scrollbar ao passar o mouse
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fillOpacity = 0.3;

    //Adiciona legenda
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#000");

    //Adiciona cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = [series, seriesPotenciaInstalada];

    //configura a cor do tooltip x
    const dateAxisTooltip = dateAxis.tooltip;
    dateAxisTooltip.background.fill = am4core.color("#0070cc");
    dateAxisTooltip.stroke = am4core.color("#fff");
    dateAxisTooltip.background.strokeWidth = 0;
    dateAxisTooltip.background.cornerRadius = 3;
    dateAxisTooltip.background.pointerLength = 0;
    dateAxisTooltip.dy = 5;

    //configura a cor do tooltip y
    const valueAxisTooltip = valueAxis.tooltip;
    valueAxisTooltip.background.fill = am4core.color("#0070cc");
    valueAxisTooltip.stroke = am4core.color("#fff");
    valueAxisTooltip.background.strokeWidth = 0;
    valueAxisTooltip.background.cornerRadius = 3;
    valueAxisTooltip.background.pointerLength = 0;
    valueAxisTooltip.dy = 5;

    valueAxis.renderer.line.strokeOpacity = 1;
    valueAxis.renderer.line.strokeWidth = 2;

    chart.data = lista.map((leitura) => {
        const { potencia_instantanea, potencia_instalada, data_hora, ...rest } = leitura;
        return { potencia_instantanea, potencia_instalada, data_hora: new Date(data_hora) };
    });

    //deixa botoes da barra de rolagem quadrados
    customizeChartGrip(chart.scrollbarX.startGrip);
    customizeChartGrip(chart.scrollbarX.endGrip);

    setChart(chart);
}

export function montarGraficoColunasEnergiaDiasMes({ id, lista, setChart, subtitulo }) {
    am4core.useTheme(am4themes_animated);
    lista.map((item) => (item.icone = weatherIcons[item.nome_icone]));
    let chart = am4core.create(id, am4charts.XYChart);
    const subtitle = chart.titles.create();
    subtitle.text = subtitulo;
    subtitle.fontWeight = "bold";
    subtitle.fontSize = window.innerWidth < 1150 ? "0.7rem" : "1rem";
    subtitle.fill = am4core.color("#000");
    subtitle.marginBottom = 30;

    const title = chart.titles.create();
    title.text = "Energia Gerada no Mês";
    title.fontWeight = "bold";
    title.fontSize = window.innerWidth < 1150 ? "0.8rem" : "1.2rem";
    title.fill = am4core.color("#000");
    title.marginBottom = 30;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.items = [
        {
            label: "...",
            menu: [
                {
                    type: "png",
                    label: "PNG",
                },
            ],
        },
    ];
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.minGridDistance = 30;
    dateAxis.startLocation = 0;
    dateAxis.endLocation = 1;

    dateAxis.dateFormats.setKey("day", "dd/MM\nEEE");

    dateAxis.markUnitChange = false;
    dateAxis.baseInterval = {
        timeUnit: "day",
        count: 1,
    };

    dateAxis.renderer.labels.template.fontSize = 12;
    dateAxis.renderer.labels.template.textAlign = "middle";
    dateAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo x

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    if (chart.yAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
    }

    valueAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo y
    valueAxis.min = 0;

    const serieProducaoEsperadaDia = chart.series.push(new am4charts.LineSeries());
    serieProducaoEsperadaDia.dataFields.valueY = "producao_esperada_dia";
    serieProducaoEsperadaDia.dataFields.dateX = "data";
    serieProducaoEsperadaDia.yAxis = valueAxis;
    serieProducaoEsperadaDia.name = "Produção esperada do dia";
    serieProducaoEsperadaDia.tooltipText = `Produção esperada: [bold]{valueY.formatNumber("###,###,###,###.00")} kWh[/]`;
    serieProducaoEsperadaDia.stroke = am4core.color("#cd2236");
    serieProducaoEsperadaDia.fill = am4core.color("#cd2236");
    serieProducaoEsperadaDia.strokeWidth = 2;

    // Adiciona bolinhas (círculos) nos pontos da linha
    const bulletProducaoEsperada = serieProducaoEsperadaDia.bullets.push(new am4charts.CircleBullet());
    bulletProducaoEsperada.circle.radius = 4; // Tamanho da bolinha
    bulletProducaoEsperada.circle.fill = am4core.color("#cd2236"); // Cor da bolinha
    bulletProducaoEsperada.circle.strokeWidth = 2;
    bulletProducaoEsperada.circle.stroke = am4core.color("#fff"); // Cor da borda

    // Create series
    const serieEnergiaDia = chart.series.push(new am4charts.ColumnSeries());
    serieEnergiaDia.dataFields.valueY = "energia_dia";
    serieEnergiaDia.dataFields.dateX = "data";
    serieEnergiaDia.yAxis = valueAxis;
    serieEnergiaDia.name = "Energia gerada por dia";
    serieEnergiaDia.tooltipText = `Energia gerada em {dateX.formatDate("dd/MM/yyyy, EEEE")}: [bold]{valueY.formatNumber("###,###,###,###.00")} kWh[/]`;
    serieEnergiaDia.stroke = am4core.color("#017acd");
    serieEnergiaDia.fill = am4core.color("#017acd");
    serieEnergiaDia.fillOpacity = 0.2;

    // Do not crop bullets
    chart.maskBullets = false;

    // Remove padding
    chart.paddingBottom = 0;

    // Adiciona imagens acima das colunas
    const bullet = serieEnergiaDia.bullets.push(new am4charts.Bullet());
    const image = bullet.createChild(am4core.Image);
    image.horizontalCenter = "middle";
    image.dy = -50;
    image.width = 40;
    image.y = am4core.percent(100);
    image.propertyFields.href = "icone";
    image.tooltipText = serieEnergiaDia.columns.template.tooltipText;
    image.propertyFields.fill = "color";
    image.filters.push(new am4core.DropShadowFilter());

    //Estilo da scrollbar
    chart.scrollbarX = new am4charts.XYChartScrollbar();
    chart.scrollbarX.series.push(serieProducaoEsperadaDia);
    chart.scrollbarX.series.push(serieEnergiaDia);
    chart.scrollbarX.unselectedOverlay.fill = am4core.color("#fff");
    chart.scrollbarX.unselectedOverlay.fillOpacity = 0.7;
    chart.scrollbarX.unselectedOverlay.stroke = am4core.color("#fff");

    chart.scrollbarX.background.fill = am4core.color("#fff");
    chart.scrollbarX.thumb.background.fill = am4core.color("#2190ff"); //cor do trecho selecionado
    chart.scrollbarX.thumb.background.fillOpacity = 0.3; //opacidade da cor do trecho selecionado
    chart.scrollbarX.stroke = am4core.color("#003040"); // cor do texto dentro do trecho seleionado
    chart.scrollbarX.strokeWidth = 0;

    //Cor da scrollbar ao passar o mouse
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fillOpacity = 0.3;

    //Adiciona legenda
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#000");

    //Adiciona cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = [serieProducaoEsperadaDia, serieEnergiaDia];

    //configura a cor do tooltip x
    const dateAxisTooltip = dateAxis.tooltip;
    dateAxisTooltip.background.fill = am4core.color("#0070cc");
    dateAxisTooltip.stroke = am4core.color("#fff");
    dateAxisTooltip.background.strokeWidth = 0;
    dateAxisTooltip.background.cornerRadius = 3;
    dateAxisTooltip.background.pointerLength = 0;
    dateAxisTooltip.dy = 5;
    dateAxisTooltip.label.textAlign = "middle";

    //configura a cor do tooltip y
    const valueAxisTooltip = valueAxis.tooltip;
    valueAxisTooltip.background.fill = am4core.color("#0070cc");
    valueAxisTooltip.stroke = am4core.color("#fff");
    valueAxisTooltip.background.strokeWidth = 0;
    valueAxisTooltip.background.cornerRadius = 3;
    valueAxisTooltip.background.pointerLength = 0;
    valueAxisTooltip.dy = 5;
    valueAxis.extraMax = 0.3;

    valueAxis.renderer.line.strokeOpacity = 1;
    valueAxis.renderer.line.strokeWidth = 2;

    chart.data = lista;

    //deixa botoes da barra de rolagem quadrados
    customizeChartGrip(chart.scrollbarX.startGrip);
    customizeChartGrip(chart.scrollbarX.endGrip);

    setChart(chart);
}

export function montarGraficoColunasEnergiaMesesAno({ id, lista, setChart, subtitulo }) {
    am4core.useTheme(am4themes_animated);

    let chart = am4core.create(id, am4charts.XYChart);
    const subtitle = chart.titles.create();
    subtitle.text = subtitulo;
    subtitle.fontWeight = "bold";
    subtitle.fontSize = window.innerWidth < 1150 ? "0.7rem" : "1rem";
    subtitle.fill = am4core.color("#000");
    subtitle.marginBottom = 30;

    const title = chart.titles.create();
    title.text = "Energia Gerada no Ano";
    title.fontWeight = "bold";
    title.fontSize = window.innerWidth < 1150 ? "0.8rem" : "1.2rem";
    title.fill = am4core.color("#000");

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.items = [
        {
            label: "...",
            menu: [
                {
                    type: "png",
                    label: "PNG",
                },
            ],
        },
    ];
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.language.locale["_date_month"] = "MMM";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";
    chart.paddingTop = 20; // Ajuste conforme necessário

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.minGridDistance = 30;
    dateAxis.startLocation = 0;
    dateAxis.endLocation = 1;
    dateAxis.dateFormats.setKey("month", "MMM");
    dateAxis.periodChangeDateFormats.setKey("month", "MMM");
    dateAxis.baseInterval = {
        timeUnit: "month",
        count: 1,
    };
    // dateAxis.renderer.labels.template.fontSize = 20;
    dateAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo x

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    if (chart.yAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
    }

    valueAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo y
    valueAxis.min = 0;
    valueAxis.extraMax = 0.2; // Adiciona espaço extra no topo

    const serieProducaoEsperadaMes = chart.series.push(new am4charts.LineSeries());
    serieProducaoEsperadaMes.dataFields.valueY = "projetado";
    serieProducaoEsperadaMes.dataFields.dateX = "data";
    serieProducaoEsperadaMes.yAxis = valueAxis;
    serieProducaoEsperadaMes.name = "Produção esperada do mês";
    serieProducaoEsperadaMes.tooltipText = `Produção esperada: [bold]{valueY.formatNumber("###,###,###,###.00")} kWh[/]`;
    serieProducaoEsperadaMes.stroke = am4core.color("#cd2236");
    serieProducaoEsperadaMes.fill = am4core.color("#cd2236");
    serieProducaoEsperadaMes.strokeWidth = 2;

    // Adiciona bolinhas (círculos) nos pontos da linha
    const bullet = serieProducaoEsperadaMes.bullets.push(new am4charts.CircleBullet());
    bullet.circle.radius = 4; // Tamanho da bolinha
    bullet.circle.fill = am4core.color("#cd2236"); // Cor da bolinha
    bullet.circle.strokeWidth = 2;
    bullet.circle.stroke = am4core.color("#fff"); // Cor da borda

    // Create series
    const serieEnergiaMes = chart.series.push(new am4charts.ColumnSeries());
    serieEnergiaMes.dataFields.valueY = "energia_mes";
    serieEnergiaMes.dataFields.dateX = "data";
    serieEnergiaMes.yAxis = valueAxis;
    serieEnergiaMes.name = "Energia gerada por mês";
    serieEnergiaMes.tooltipText = `Energia gerada em {dateX.formatDate("MMM yyyy")}: [bold]{valueY.formatNumber("###,###,###,###.00")} kWh[/]`;
    serieEnergiaMes.stroke = am4core.color("#017acd");
    serieEnergiaMes.fill = am4core.color("#017acd");
    serieEnergiaMes.fillOpacity = 0.4;

    //Estilo da scrollbar
    chart.scrollbarX = new am4charts.XYChartScrollbar();
    chart.scrollbarX.series.push(serieProducaoEsperadaMes);
    chart.scrollbarX.series.push(serieEnergiaMes);
    chart.scrollbarX.unselectedOverlay.fill = am4core.color("#fff");
    chart.scrollbarX.unselectedOverlay.fillOpacity = 0.7;
    chart.scrollbarX.unselectedOverlay.stroke = am4core.color("#fff");

    chart.scrollbarX.background.fill = am4core.color("#fff");
    chart.scrollbarX.thumb.background.fill = am4core.color("#2190ff"); //cor do trecho selecionado
    chart.scrollbarX.thumb.background.fillOpacity = 0.3; //opacidade da cor do trecho selecionado
    chart.scrollbarX.stroke = am4core.color("#003040"); // cor do texto dentro do trecho seleionado
    chart.scrollbarX.strokeWidth = 0;

    //Cor da scrollbar ao passar o mouse
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.startGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.endGrip.background.states.getKey("hover").properties.fillOpacity = 0.3;

    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fill = am4core.color("#2190ff");
    chart.scrollbarX.thumb.background.states.getKey("hover").properties.fillOpacity = 0.3;

    //Adiciona legenda
    chart.legend = new am4charts.Legend();
    chart.legend.labels.template.fill = am4core.color("#000");

    //Adiciona cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = [serieEnergiaMes, serieProducaoEsperadaMes];

    //configura a cor do tooltip x
    const dateAxisTooltip = dateAxis.tooltip;
    dateAxisTooltip.background.fill = am4core.color("#0070cc");
    dateAxisTooltip.stroke = am4core.color("#fff");
    dateAxisTooltip.background.strokeWidth = 0;
    dateAxisTooltip.background.cornerRadius = 3;
    dateAxisTooltip.background.pointerLength = 0;
    dateAxisTooltip.dy = 5;

    //configura a cor do tooltip y
    const valueAxisTooltip = valueAxis.tooltip;
    valueAxisTooltip.background.fill = am4core.color("#0070cc");
    valueAxisTooltip.stroke = am4core.color("#fff");
    valueAxisTooltip.background.strokeWidth = 0;
    valueAxisTooltip.background.cornerRadius = 3;
    valueAxisTooltip.background.pointerLength = 0;
    valueAxisTooltip.dy = 5;

    valueAxis.renderer.line.strokeOpacity = 1;
    valueAxis.renderer.line.strokeWidth = 2;

    chart.data = lista;

    chart.data = lista.map((item) => ({
        ...item,
        desempenho: item.projetado ? ((item.energia_mes * 100) / item.projetado).toFixed(2) : 0,
    }));

    const labelBullet = serieEnergiaMes.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.text = '{desempenho.formatNumber("###.###.###.###,00")}%';
    labelBullet.label.fill = am4core.color("#222"); // Cor do texto para contrastar com a barra
    labelBullet.label.fontSize = 14; // Define o tamanho da fonte
    labelBullet.label.fontWeight = "bold"; // Define o texto como negrito
    labelBullet.label.horizontalCenter = "middle";
    labelBullet.label.verticalCenter = "middle"; // Mantém o label dentro da coluna
    labelBullet.dy = -20; // Ajuste fino se necessário

    customizeChartGrip(chart.scrollbarX.startGrip);
    customizeChartGrip(chart.scrollbarX.endGrip);
    setChart(chart);
}

export function montarGraficoLineTodasIntegracoesAgrupadasPorHora({ id, lista, setChart }) {
    am4core.useTheme(am4themes_animated);
    let chart = am4core.create(id, am4charts.XYChart);
    const title = chart.titles.create();
    title.text = "Energia Gerada no Dia";
    title.fontWeight = "bold";
    title.fontSize = "0.9rem";
    // title.fill = am4core.color("#000");
    title.fill = am4core.color("#fff");
    title.marginBottom = 10;

    chart.exporting.menu = new am4core.ExportMenu();
    chart.exporting.filePrefix = "Gráfico";
    chart.exporting.menu.align = "right";
    chart.exporting.menu.verticalAlign = "top";
    chart.exporting.menu.items = [
        {
            label: "...",
            menu: [
                {
                    type: "png",
                    label: "PNG",
                },
            ],
        },
    ];
    chart.language.locale = locale;
    chart.language.locale["_decimalSeparator"] = ",";
    chart.language.locale["_thousandSeparator"] = ".";
    chart.numberFormatter.numberFormat = "###,###,###,###.00";
    chart.background.fill = "#1e3e49";
    chart.background.opacity = 1;

    // Create axes
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.startLocation = 0.5;
    dateAxis.endLocation = 0.5;
    dateAxis.dateFormats.setKey("minute", "HH:mm");
    // dateAxis.periodChangeDateFormats.setKey("minute", "hh:mm");
    dateAxis.baseInterval = {
        timeUnit: "minute",
        count: 5,
    };
    // dateAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo x
    dateAxis.renderer.labels.template.fill = am4core.color("#fff"); //cor do texto eixo x
    dateAxis.renderer.maxLabelPosition = 0.95;
    dateAxis.renderer.minGridDistance = 40;
    dateAxis.renderer.minLabelPosition = 0.05;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    if (chart.yAxes.indexOf(valueAxis) != 0) {
        valueAxis.syncWithAxis = chart.yAxes.getIndex(0);
    }
    valueAxis.min = 0;
    // valueAxis.renderer.labels.template.fill = am4core.color("#000"); //cor do texto eixo y
    valueAxis.renderer.labels.template.fill = am4core.color("#fff"); //cor do texto eixo y
    // Create series
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = "potencia_instantanea_media_hora";
    series.dataFields.dateX = "data_hora";
    series.yAxis = valueAxis;
    series.name = "Energia gerada ao longo do dia";
    series.tooltipText = `Potência Instantânea às {dateX.formatDate("HH:mm")}h: [bold]{valueY.formatNumber("###,###,###,###.00")} kW[/]`;
    series.strokeWidth = 2;
    series.tensionX = 1;
    series.stacked = true;
    series.stroke = am4core.color("#017acd");
    series.fill = am4core.color("#017acd");
    series.fillOpacity = 0.2;

    //Adiciona cursor
    chart.cursor = new am4charts.XYCursor();
    chart.cursor.xAxis = dateAxis;
    chart.cursor.snapToSeries = series;

    //configura a cor do tooltip x
    const dateAxisTooltip = dateAxis.tooltip;
    dateAxisTooltip.background.fill = am4core.color("#0070cc");
    dateAxisTooltip.stroke = am4core.color("#fff");
    dateAxisTooltip.background.strokeWidth = 0;
    dateAxisTooltip.background.cornerRadius = 3;
    dateAxisTooltip.background.pointerLength = 0;
    dateAxisTooltip.dy = 5;

    //configura a cor do tooltip y
    const valueAxisTooltip = valueAxis.tooltip;
    valueAxisTooltip.background.fill = am4core.color("#0070cc");
    valueAxisTooltip.stroke = am4core.color("#fff");
    valueAxisTooltip.background.strokeWidth = 0;
    valueAxisTooltip.background.cornerRadius = 3;
    valueAxisTooltip.background.pointerLength = 0;
    valueAxisTooltip.dy = 5;

    valueAxis.renderer.line.strokeOpacity = 1;
    valueAxis.renderer.line.strokeWidth = 2;

    chart.data = lista.map((leitura) => {
        const { potencia_instantanea_media_hora, data_hora, ...rest } = leitura;
        return { potencia_instantanea_media_hora, data_hora: new Date(data_hora) };
    });

    setChart(chart);
}
